import { render, staticRenderFns } from "./CreateList.vue?vue&type=template&id=fb976dda&"
import script from "./CreateList.vue?vue&type=script&lang=js&"
export * from "./CreateList.vue?vue&type=script&lang=js&"
import style0 from "./CreateList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports